import { East, West } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import successImg from "../../../assets/images/check-mark-success.gif";

const PaymentSuccess = ({ handleContinue }) => {
  return (
    <Stack
      className="bg-[#FFFFFF] w-full h-[80vh] py-4 px-5"
      sx={{ padding: "15px" }}
      direction={"column"}
      alignItems={"center"}
      justifyContent={"center"}
      spacing={3}
    >
      <img src={successImg} width={100} loading="lazy" />
      <h1 className="text-4xl my-3 font-['Poppins-Medium']">Thank You!</h1>
      <h1 className="text-lg font-[400] my-3 font-['Poppins-Medium']">
        Payment Done Successfully
      </h1>
      <Button
        onClick={handleContinue}
        startIcon={<West />}
        className="bg-[#2F80ED] py-2 px-4 text-white normal-case font-['Poppins-Medium']"
      >
        Continue
      </Button>
    </Stack>
  );
};

export default PaymentSuccess;
